import { createRouter, createWebHashHistory } from 'vue-router'
// import { createRouter, createWebHistory } from 'vue-router'

// 路由数组
const routes = [
    {
        path: `/agent/idnapk/:id`,
        meta: {
            title: 'Slots Go', 
            icon: './static/slots_go.png' 
        },
        component: ()=>import('../components/HelloWorld.vue')
    },
    {
        path: `/agent/idnh5/:id`,
        meta: {
            title: 'Vip 777', 
            icon: './static/vip777.png'
        },
        component: ()=>import('../components/HelloWorld.vue')
    }
]



// 创建路由对象
const router = createRouter({
    history: createWebHashHistory(),
    // history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'Slots Go'; // 设置页面标题
    next();
  });
  
  router.afterEach((to) => {
    const icon = to.meta.icon || './static/slots_go.png'; // 获取页面图标
    const link = document.querySelector("link[rel~='icon']") || document.createElement('link'); // 获取或创建<link>标签
    link.type = 'image/x-icon'; // 设置图标类型
    link.rel = 'shortcut icon'; // 设置链接类型
    link.href = icon; // 设置图标链接
    document.getElementsByTagName('head')[0].appendChild(link); // 添加<link>标签到<head>标签中
  });

export default router
